import { render, staticRenderFns } from "./DeleteEmployeeButton.vue?vue&type=template&id=4bba048d&scoped=true&"
import script from "./DeleteEmployeeButton.vue?vue&type=script&lang=js&"
export * from "./DeleteEmployeeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba048d",
  null
  
)

export default component.exports